// Market-type names by SportRadar premium market group (the prefix of the market id), shared by
// the Leak Ledger and SR Fallback Holds pages so both read the same.
export const CATEGORY_LABELS: { [key: string]: string } = {
  "340": "Winner",
  "356": "Only Over",
  "357": "Only Over",
  "1148": "Only Over",
  "1149": "Only Over",
  "638": "Player Run",
  "1229": "Session",
  "1230": "Session",
  "1150": "Session",
  "1151": "Session",
  "877": "Lambi",
  "878": "Lambi",
  "875": "Wicket",
  "876": "Wicket",
};

export function marketCategoryLabel(code: string): string {
  return CATEGORY_LABELS[code] ? `${CATEGORY_LABELS[code]} (${code})` : `Category ${code}`;
}
